const config = {
  graphqlUri: process.env.REACT_APP_GRAPHQL_CLIENT,
  defaultVendorId: process.env.REACT_APP_DEFAULT_VENDOR_ID,
};

export default config;
